module.exports = __webpack_public_path__ + "img/heart_light_green.72f98322.svg";